import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import Select from "react-select";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const BillPaymentList = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [totalData, setTotalData] = useState(0);
  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [classicView, setClassicView] = useState(true);
  const handleDropdownChange = (event) => {
    console.log(event.value, "value1234");
    setSelectReport(event.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/billpayment?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&supplierid=${0}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            Account: el.Account ? el.Account : "",
            Date: el.Date ? el.Date : "",
            CreateDate: el.CreateDate ? el.CreateDate : "",
            Vendor: el.Vendor ? el.Vendor : "",
            Name: el.Name ? el.Name : "",
            Amount: Number(el.Amount),
            NUM: el.NUM ? el.NUM : "",
            Description: el.Description ? el.Description : "",
            ApPaid: el.ApPaid ? el.ApPaid : "",
            ArPaid: el.ArPaid ? el.ArPaid : "",
            AccountType: el.AccountType ? el.AccountType : "",
            CreatedBy: el.CreatedBy ? el.CreatedBy : "",
            LastModified: el.LastModified ? el.LastModified : "",
            LastModifiedBy: el.LastModifiedBy ? el.LastModifiedBy : "",
            PaymentMethod: el.PaymentMethod ? el.PaymentMethod : "",
            TransactionType: el.TransactionType ? el.TransactionType : "",
          }));
          setResponseData(FilterData);
          setTotalData(
            FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.Amount) || 0),
              0
            )
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   apicall();
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  // ]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Account Name",
      accessorKey: "Account",
      size: "110",
      filterFn: "contains",
      Footer: () => <Box>TOTAL</Box>,
    },
    {
      header: "Payment Date",
      accessorKey: "Date",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        const Date = moment(row.original.Date);
        if (Date.isValid()) {
          return moment(Date).format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Num",
      accessorKey: "NUM",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Vendor Name",
      accessorKey: "Vendor",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            textAlign: "end",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() =>
            window.open(`/receiving-paybills/${row.original.TxnId}`, "_blank")
          }
        >
          {CurrencySymbols(
            Number(row.original.Amount),
            CurrencySymbol,
            FractionDigits
          )}
        </Box>
      ),
      // Cell: ({ row }) => {
      //   const TotalAmount = row?.original?.Amount;

      //   return (
      //     <div style={{ textAlign: "end" }}>
      //       {CurrencySymbols(
      //         Number(TotalAmount),
      //         { CurrencySymbol },
      //         FractionDigits
      //       )}
      //     </div>
      //   );
      // },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
      Footer: () => (
        <Box>
          <div style={{ textAlign: "end" }}>
            {/* style={{ textAlign: "end" }} */}
            {CurrencySymbols(
              Number(totalData),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        </Box>
      ),
    },
    {
      header: "A/P Paid",
      accessorKey: "ApPaid",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Cleared",
      accessorKey: "Cleared",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "A/R Paid",
      accessorKey: "ArPaid",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Account Type",
      accessorKey: "AccountType",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Created Date",
      accessorKey: "CreateDate",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreateDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
      size: "110",
      filterFn: "contains",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.LastModified;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      size: "110",
      filterFn: "contains",
    },
    {
      header: "Description",
      size: "110",
      filterFn: "contains",
      accessorKey: "Description",
    },
    {
      header: "Payment Method",
      size: "110",
      filterFn: "contains",
      accessorKey: "PaymentMethod",
    },
    {
      header: "Transaction Type",
      size: "110",
      filterFn: "contains",
      accessorKey: "TransactionType",
    },
    {
      header: "Account Full Name",
      size: "110",
      filterFn: "contains",
      accessorKey: "AccountFullName",
    },
  ]);

  const headerMenu = function () {
    const table = this;
    const menu = [];
    const columns = table.getColumns();

    // Check if we have saved visibility state in localStorage
    const savedVisibility = localStorage.getItem("columnVisibility");
    const visibilityState = savedVisibility ? JSON.parse(savedVisibility) : {};

    for (let column of columns) {
      const field = column.getField();
      const columnDef = column.getDefinition();
      const defaultVisible = columnDef.defaultVisible == true; // Default to true if not specified

      console.log(visibilityState, "visibilityState", defaultVisible);

      // Determine initial visibility:
      // 1. Use saved state if available
      // 2. Fall back to defaultVisible if no saved state
      const shouldBeVisible = visibilityState.hasOwnProperty(field)
        ? visibilityState[field]
        : defaultVisible;

      // Set column visibility
      if (shouldBeVisible) {
        column.show();
      } else {
        column.hide();
      }

      // Create menu item with icon
      const icon = document.createElement("i");
      icon.classList.add("fas");
      icon.classList.add(column.isVisible() ? "fa-check-square" : "fa-square");

      const label = document.createElement("span");
      const title = document.createElement("span");
      title.textContent = " " + columnDef.title;
      label.appendChild(icon);
      label.appendChild(title);

      menu.push({
        label: label,
        action: function (e) {
          e.stopPropagation();

          // Toggle visibility
          const newVisibility = !column.isVisible();
          if (newVisibility) {
            column.show();
            icon.classList.remove("fa-square");
            icon.classList.add("fa-check-square");
          } else {
            column.hide();
            icon.classList.remove("fa-check-square");
            icon.classList.add("fa-square");
          }

          // Update and save visibility state
          visibilityState[field] = newVisibility;
          localStorage.setItem(
            "columnVisibility",
            JSON.stringify(visibilityState)
          );
        },
      });
    }

    return menu;
  };

  useEffect(() => {
    localStorage.removeItem("columnVisibility");
  }, []);

  const Classiccolumns = [
    {
      title: "Account Name",
      field: "Account",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "Date",
      field: "Date",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Num",
      field: "NUM",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
    },
      {
      title: "Vendor Name",
      field: "Vendor",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");

        span.textContent = data.Vendor || "";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.display = "flex";
        span.style.alignItems = "center";
        span.style.overflow = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.textOverflow = "ellipsis";
        span.style.fontWeight = "900";

       span.addEventListener("click", (e) => {
          e.preventDefault();
          const type = data.TransactionType;
          const BillID = data.TxnId;
          let url = `/Expense/${BillID}`; // default

          if (type == "Bill Payment") {
            url = `/receiving-paybills/${BillID}`;
          } 

          window.open(url, "_blank");
        });


        return span;
      },
    },
    {
      title: "Vendor Name",
      field: "Vendor",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Amount",
      field: "Amount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");

        span.textContent = data.Amount || "";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.display = "flex";
        span.style.alignItems = "center";
        span.style.overflow = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.textOverflow = "ellipsis";
        span.style.fontWeight = "900";

        span.addEventListener("click", (e) => {
          e.preventDefault();
          const type = data.TransactionType;
          const BillID = data.TxnId;
          let url = `/Expense/${BillID}`; // default

          if (type == "Bill Payment") {
            url = `/receiving-paybills/${BillID}`;
          } 

          window.open(url, "_blank");
        });

        return span;
      },
    },
    {
      title: "A/P Paid",
      field: "ApPaid",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "A/R Paid",
      field: "ArPaid",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Account Type",
      field: "AccountType",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Created Date",
      field: "CreateDate",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Created By",
      field: "CreatedBy",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Last Modified",
      field: "LastModified",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Last Modified By",
      field: "LastModifiedBy",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
    },
    {
      title: "Description",
      field: "Description",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
    },
    {
      title: "Payment Method",
      field: "PaymentMethod",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
    },
    {
      title: "Transaction Type",
      field: "TransactionType",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
    },
    {
      title: "Account Full Name",
      field: "AccountFullName",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
    },
     {
      title: "Cleared",
      field: "Cleared",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      // defaultVisible: true,
    },
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const defaultColDef = {
    sortable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  const totalFooterRow = {
    Name: "Total",
    Amount: totalSum,
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Bill Payment List</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    value={reportdropdown.find(
                      (el) => el.value === selectReport
                    )}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={reportdropdown.find((el,i)=> el.value==selectedDate)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 classname="p">SonarPos</h6>
                    <p className="fw-bold p-regular">Bill Payment List</p>
                    <div className="row mb-2">
                      {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "Classic View" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}
                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      Groupvalue={["Account"]}
                      Reportname={"Bill Payment List"}
                      frozenRowvalue={0}
                      // layout={"fitDataFill"}
                      Onrefresh={() => apicall()}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Bill Payment List"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={["Account"]}
                      enableExpandAll={true}
                      enableExpanding={true}
                      expanded={true}
                      enableRowSelection={false}
                      columnsVisibility={{
                        ApPaid: false,
                        ArPaid: false,
                        AccountType: false,
                        CreateDate: false,
                        CreatedBy: false,
                        LastModified: false,
                        LastModifiedBy: false,
                        Description: false,
                        PaymentMethod: false,
                        TransactionType: false,
                        AccountFullName: false,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BillPaymentList;
